import { clx } from '@medusajs/ui';

import type { TextNode } from './types';

export const Text = (props: TextNode) => {
  // Payload CMS Lexical editor may emit empty text nodes as formatting placeholders
  // (e.g., between inline elements or at line boundaries)
  // Return null to avoid rendering empty <span> elements in the DOM
  if (props.text === '') {
    return null;
  }
  return (
    <span
      className={clx({
        'font-bold': props.bold,
        italic: props.italic,
        underline: props.underline,
        'line-through': props.strikethrough,
      })}
    >
      {props.text}
    </span>
  );
};
